import { PackageTypeForm } from "@/resources/packages/PackageTypeForm";

export function FrameCreate() {
  return (
    <PackageTypeForm
      action="create"
      resource="frames"
      packageType="frame"
      label="Frame"
    />
  );
}

export default FrameCreate;
